
import { useState } from "react";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { GET_DETAILS_FROM_CARD} from "../../api/apiRoutes";
import { WebUser } from "../../models/WebUser";


export default function useCardPurchaseLookup() {
  const { get } = useApiRequest();
  const [cardDetails, setCardDetails] = useState<WebUser>();


  const getDetailsByCardID = async (facilityids: string, code: string) => {
    console.log("TEST")
    const ids = `0,${facilityids}`;
    const { result, isError } = await get(GET_DETAILS_FROM_CARD(ids, code));
    if (!isError) {
      setCardDetails(result);
    }
  };

  return {
    getDetailsByCardID,
    cardDetails,
  };
}
